<template>
  <div
    class="relative cursor-pointer outline-none"
    :class="getCSS"
    @click="videoClicked"
    @focusout="timesClicked = 0"
    tabindex="0"
  >
    <div
      class="preview absolute flex flex-wrap w-full py-1 md:p-3 content-between h-full"
    >
      <!-- Tools -->
      <div
        class="tools flex w-full opacity-0 transition duration-500 ease-in-out justify-end"
      >
        <!-- <template v-for="(obj, index) in tools">
          <div v-if="!obj.src" class="w-3/6" :key="index"></div>
          <button
            v-else
            class="cursor-pointer bg-black w-1/6 rounded-full mx-1"
            :key="index"
            @click.stop="buttonClicked(obj.name)"
          >
            <img
              :src="obj.src"
              :alt="obj.alt"
              loading="lazy"
              class="invert-image"
              :class="index !== 0 ? 'p-1' : ''"
            />
          </button>
        </template> -->
        <button
          v-for="(n, index) in 2"
          class="overflow-hidden bg-white w-8 h-8 rounded-full"
          :class="n == 1 ? 'mx-1' : ''"
          @click.stop=""
          :key="index"
        >
          <ShareNetwork
            :network="`${n == 1 ? 'facebook' : 'twitter'}`"
            :url="getLink(video.video.url)"
            :title="getVideoTitle(n == 1)"
            :quote="getVideoQuote(n == 1)"
            :description="`${video.longQuestion}`"
            :hashtags="
              `Edufutures,${video.discipline.join().replace(/\s/g, '')}`
            "
          >
            <img
              v-if="n == 1"
              src="../assets/facebook-icon.svg"
              alt="Facebook icon"
            />
            <img v-else src="../assets/twitter-icon.svg" alt="Twitter icon" />
          </ShareNetwork>
        </button>

        <!--  <button class="bg-white w-8 h-8 rounded-full mx-1" @click.stop="">
          <ShareNetwork
            network="twitter"
            url="https://news.vuejs.org/issues/180"
            title="Say hi to Vite! A brand new, extremely fast development setup for Vue."
            description="This week, I’d like to introduce you to 'Vite', which means 'Fast'. It’s a brand new development setup created by Evan You."
            quote="The hot reload is so fast it\'s near instant. - Evan You"
            hashtags="vuejs,vite"
          >
            <img src="../assets/twitter-icon.png" alt="Twitter icon" />
          </ShareNetwork>
        </button> -->
      </div>

      <div
        class="w-auto opacity-100 rounded-full bg-black bg-opacity-50 text-white text-xs py-2 px-3 mx-1 select-none 2xl:text-2xl"
      >
        {{ video.question }}
      </div>
    </div>
    <img
      :src="video.videoStillImage.url"
      loading="lazy"
      class="main-background"
      alt="Video still image"
    />
  </div>
</template>

<style scoped>
.preview:hover .tools {
  opacity: 1;
}

.preview-small {
  height: 200px;
}

.preview-big {
  height: 300px;
}

.main-background {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.invert-image {
  filter: invert(1);
}
</style>

<script>
import { mapMutations, mapGetters } from "vuex";
// Import assets
import marker from "../assets/marker-black-icon.png";

/* Utilities */
import { getID, getLink } from "../utilities";

export default {
  props: {
    video: Object,
    index: Number,
  },
  mounted() {
    // console.log(this.video);
  },
  computed: {
    ...mapGetters(["getIsMobile"]),
    getCSS() {
      const index = this.index;
      if (this.getIsMobile === true) {
        return index % 2 === 0
          ? "row-span-2 preview-big"
          : "row-span-1 preview-small";
      } else {
        const row = Math.floor(index / 10) * 10;
        if (
          index === 0 + row ||
          index === 2 + row ||
          index === 4 + row ||
          index === 5 + row ||
          index === 6 + row
        )
          return "row-span-2 sm:h-md-big lg:h-lg-big xl:h-xl-big 2xl:h-4Kdb";
        else
          return "row-span-1 sm:h-md-small lg:h-lg-small xl:h-xl-small 2xl:h-4Kds";
      }
    },
  },
  data() {
    return {
      tools: [{ network: "facebook" }, { network: "twitter" }],
      timesClicked: 0,
      getLink,
    };
  },
  methods: {
    ...mapMutations(["setVideo"]),
    downloadVideo(videoURL) {
      fetch({
        method: "GET",
        url: videoURL,
        responseType: "arraybuffer",
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "video.mp4"); //or any other extension
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          console.error("Error: ", error);
        });
    },
    buttonClicked(str) {
      // Index 1 is used for creating space
      const buttons = this.tools;
      const metadata = this.video;
      if (str === buttons[0].name) console.log(str + " clicked");
      else if (str === buttons[2].name) this.downloadVideo(metadata.video.url);
      else if (str === buttons[3].name) console.log(str + " clicked");
    },
    videoClicked() {
      if (!this.getIsMobile || this.timesClicked > 0) {
        const id = getID(this.video.video.url);
        this.$router.push(`/video/${id}`);
      } else this.timesClicked++;
    },
    getVideoTitle(isFacebook) {
      return isFacebook
        ? ""
        : `${this.video.question}\n${this.video.longQuestion}\n`;
    },
    getVideoQuote(isFacebook) {
      return isFacebook
        ? `${this.video.question}\n${this.video.longQuestion}\n`
        : "";
    },
  },
};
</script>
